import { edgeFunctionData } from '../../services/edgeFunctionData';
import { fetchDayWorklogs } from '../../services/jiraSync';
import { fetchMonthTimesheets } from '../../services/timesheets';
import { notify } from '../../store/feedback';
import { isoStr } from '../../utils/dates';
import { dayDraftFromEntries } from './dayDraft';

/* Feuilles de temps d'un mois, et ouverture de la saisie d'une journée. */
export default function timesheetMonthHandlers(deps, api) {
  const {
    resolveTimesheetUserId,
    session,
    setTimesheetDayDraft,
    setTimesheetDayJira,
    setTimesheetDay,
  } = deps;
  const { setTimesheetMonthData, appState, timesheetMonthData } = deps;

  async function loadTimesheetMonth(yearMonth, target) {
    const userId = resolveTimesheetUserId(target);
    const [year, month] = yearMonth.split('-').map(Number);
    const firstDay = `${yearMonth}-01`;
    const lastDay = isoStr(new Date(year, month, 0));
    const { data, error } = await fetchMonthTimesheets(firstDay, lastDay, userId);
    if (error) {
      console.error('loadTsMonth:', error.message);
      notify('Erreur lors du chargement des heures : ' + error.message);
    }
    const map = {};
    for (const row of data || []) {
      if (!map[row.date]) map[row.date] = [];
      map[row.date].push(row);
    }
    setTimesheetMonthData(map);
  }

  function openDayModal(dateStr, targetUserId) {
    const entries = timesheetMonthData[dateStr] || [];
    const draft = dayDraftFromEntries(entries, appState.clients);
    setTimesheetDayDraft(draft);
    setTimesheetDay(dateStr);
    loadDayJiraDetail(dateStr, targetUserId);
  }

  // Détail des worklogs Jira du jour (ticket + résumé + heures), pour aider à recouper la saisie
  // interne avec ce qui a réellement été loggé dans Jira — un dev qui a tout mis sur mardi au lieu
  // de lundi le voit tout de suite en rouvrant lundi. targetUserId : le collaborateur consulté (soi-même
  // par défaut) — un manager peut consulter celui d'un collègue, l'edge function vérifie le droit côté serveur.
  async function loadDayJiraDetail(dateStr, targetUserId) {
    setTimesheetDayJira({ loading: true });
    try {
      const payload = { date: dateStr };
      if (targetUserId && targetUserId !== session.user.id) payload.userId = targetUserId;
      const data = await edgeFunctionData(await fetchDayWorklogs(payload));
      setTimesheetDayJira({ entries: data?.entries || [] });
    } catch (e) {
      setTimesheetDayJira({ entries: [], error: e.message || 'Erreur de chargement Jira' });
    }
  }

  return { loadTimesheetMonth, openDayModal, loadDayJiraDetail };
}
